import styled from 'styled-components';

import Media from '../../../../assets/styles/media';
import THEME from '../../../../assets/styles/config';

export const ListCtn = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Overflow = styled.div`
  overflow-y: auto;
  height: 55vh;
  max-height: 475px;

  /* width */
  &::-webkit-scrollbar {
    width: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #c8cacb;
  }

  ${Media.Below.desktop`
    overflow-y: auto;
    height: 45vh;
    max-height: 450px;
  `}
`;

export const Spacer = styled.div`
  height: 100px;

  ${Media.Below.mobileLarge`
    display: none;
  `}
`;

export const SubmitBtn = styled.button`
  margin-top: 5vh;
  padding: 17px 0;
  width: 385px;
  background: ${THEME.colors.primaryColor};
  color: white;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 1.5px;
  cursor: pointer;

  ${Media.Below.desktop`
    width: 100%;
    margin-top: 35px;
    padding: 12px 0;
    font-size: 12px;
  `}
`;

export const SubmitBtnDisable = styled(SubmitBtn)`
  opacity: 0.3;
`;
